export const generateKeyByCustId = (customerId) => {
  const defaultCustomerId = 2983463946;

  let customerIdLocal, productWithCidAndLastDigit;
  if (customerId) {
    customerIdLocal = customerId;
  } else {
    customerIdLocal = defaultCustomerId;
  }

  const lastDigit = customerIdLocal % 10;
  if (lastDigit) {
    productWithCidAndLastDigit = lastDigit * customerIdLocal;
  } else {
    productWithCidAndLastDigit = 9 * customerIdLocal;
  }

  const appendedProductString = `${productWithCidAndLastDigit}${productWithCidAndLastDigit}`;
  const keySliced = appendedProductString.slice(0, 16);
  // console.log("key: ", keySliced);

  return keySliced;
};
// console.log(keyGenerator(1110000348));

export const generateInitVectorByCustId = (customerId) => {
  const defaultCustomerId = 2983463946;

  let customerIdLocal;
  if (customerId) {
    customerIdLocal = customerId;
  } else {
    customerIdLocal = defaultCustomerId;
  }

  const appendedCustomerIdString = `${customerIdLocal}${customerIdLocal}`;
  const initVectorSliced = appendedCustomerIdString.slice(0, 16);
  // console.log("iv: ", initVectorSliced);

  return initVectorSliced;
};
